import { Link } from "react-router-dom";
import "./AboutContentStyles.css";
import React from 'react';
import img from "../assets/Rishav.jpeg";

const AboutContent = () => {
    return (
        <div className="about">
            <div className="left">
                <img src={img} className="img" alt="image1" />
            </div>
            <div className="right">
                <h1>Who Am I</h1>
                <p className="details">Hey Guys. Myself Rishav Ranjan. I am a full-stack Developer who create fully responsive and functional websites for my clients.I have complete knowledge of html,css,bootstrap and javascript,
                    React Js, Node Js, PHP, MySql. I have also worked on a number of projects.I am a 3rd year
                    computer science Eng. student from Panjab university, Chandigarh. I am comfortable in both
                    working independently on a project as well as in a team. I have knowledge of some programming
                    languages like C++,DSA and Python.I have also solved a number of problems on codechef and
                    participated in many contests.I am open to work as a web developer so if you have a good
                    oppurtunity for me which matches my profile then do contact me.</p>
                <center><Link to="/contact">
                    <button className="btn">Contact</button>
                </Link></center>
            </div>
        </div>
    )
}

export default AboutContent
